import React, { useCallback, lazy, Suspense } from "react";
import { isEmpty } from "lodash";

import { useStateSelector } from "utils/field";

import Drawer from "components/Drawer";
import Button from "components/Button";
import Field from "components/Field";
import Checkbox from "components/Input/Checkbox";
import LoadingSection from "components/Loading/LoadingSection";
import Accordion from "components/Accordion";
import FileSharing from "./FileSharing";
import ReplaceWithReferenceHouse from "./ReplaceWithReferenceHouse";
import ErrorFlagging from "./ErrorFlagging";
import VersionHistory from "./VersionHistory";

import classes from "./style.module.scss";
import sharedClasses from "features/Model/sharedStyles.module.scss";

import HousesSelect from "assets/images/icons/JSX/HousesSelect";

const LazyLoadedModelDefaults = lazy(() => import("./ModelDefaults"));

const Settings = ({ change, open = false, toggleOpen }) => {
    const organization = useStateSelector(`organization`) || {};
    const { REVERT_MODEL_ENABLED = true } = useStateSelector(`user.userPermissions`) || {};
    const programClass = useStateSelector("model.modelData.program.class") || "";
    const isGeneralMode = !String(programClass).includes("ca.nrcan.gc.OEE");

    const handleClose = useCallback(() => {
        toggleOpen();
    }, [toggleOpen]);

    return (
        <Drawer open={open} title="Settings" subtitle="Model Settings" close={handleClose}>
            {!isEmpty(organization) && <FileSharing />}
            <Accordion
                className={sharedClasses.accordion}
                heading={
                    <div className={sharedClasses.accordionIconHeading}>
                        Default Model Codes <HousesSelect />
                    </div>
                }
                large
            >
                <Suspense fallback={<LoadingSection sectionLoadingName={<h3>Loading Default Model Codes</h3>} />}>
                    <LazyLoadedModelDefaults change={change} />
                </Suspense>
            </Accordion>

            <ReplaceWithReferenceHouse onReplaced={handleClose} />

            <section className={classes.simulationSetting}>
                <h3>Operating conditions</h3>
                <Field
                    component={Checkbox}
                    name="model.modelData.uiSettings.simulation.approximateSoc"
                    label="Approximate SOC in General mode"
                    type="checkbox"
                    disabled={!isGeneralMode}
                    className={classes.socCheckbox}
                />
                <p>
                    {isGeneralMode ? (
                        <>
                            When enabled, an altered copy of the file is used for General-mode simulations to
                            approximate SOC. Saved model inputs stay as entered. Useful for quick comparisons and
                            exploratory work. Read about the accuracy of this approximation in our{" "}
                            <a href="/documentation/operating-conditions" target="_blank" rel="noopener noreferrer">
                                documentation
                            </a>
                            .
                        </>
                    ) : (
                        "Available for General-mode files only. This file uses an EnerGuide program, so the approximation is not applied."
                    )}
                </p>
            </section>

            {/* {REVERT_MODEL_ENABLED && <VersionHistory />} */}

            {/* <ErrorFlagging /> */}
            <div className={classes.buttonRow}>
                <Button onClick={handleClose} type="hollow">
                    Close
                </Button>
            </div>
        </Drawer>
    );
};

export default Settings;
